import React from 'react';

/** A number that opens its drilldown. Zero is plain text: nothing sits behind it. */
const NumLink: React.FC<{ text: string; zero?: boolean; onClick: () => void; className?: string }> = ({ text, zero, onClick, className = '' }) =>
  zero ? (
    <span className={`tabular-nums text-slate-600 ${className}`}>{text}</span>
  ) : (
    <button type="button" onClick={onClick}
      className={`tabular-nums underline decoration-dotted decoration-slate-300 underline-offset-4 hover:text-violet-700 hover:decoration-violet-400 dark:hover:text-violet-300 ${className}`}>
      {text}
    </button>
  );

export default NumLink;
